const pushNavigationSubMenuEvent = (event, eventText) => {
	pushEvent(
		'navigation',
		'navigation_sub_menu_clicked',
		eventText ?? event.target.textContent,
		'general_interactions'
	);
};
const pushFiltersEvent = () => {
	pushEvent('filter_url', 'feed_url', url.href, 'browsing_interactions');
};

const pushSortByEvent = (event) => {
	const selectedIndex = event.target.selectedIndex;
	const selectedOption = event.target.options[selectedIndex];
	const selectedOptionText = selectedOption.textContent;
	pushEvent('sort', selectedOptionText, 'null', 'browsing_interactions');
};

document.addEventListener('DOMContentLoaded', function () {
	// #region - Sort by
	document.getElementById('sortBy').addEventListener('change', pushSortByEvent);
	// #endregion
});
